// Keep in sync with PreviewType in benchling/external_files/previews.py.
export enum EXTERNAL_FILE_TYPE {
  GOOGLE_DOCS_VIEWER = 'google_docs_viewer',
  MICROSOFT_OFFICE_ONLINE = 'microsoft_office_online',
  MOLSTAR_PDB_VIEWER = 'molstar_pdb_viewer',
  MOLSTAR_PDBQT_VIEWER = 'molstar_pdbqt_viewer',
  MOLSTAR_MMCIF_VIEWER = 'molstar_mmcif_viewer',
  IMAGE = 'image',
  CSV = 'csv',
  PDF = 'pdf',
  VIDEO = 'video',
  NOT_PREVIEWABLE = 'not_previewable',
}

export type MolstarFileViewer =
  | EXTERNAL_FILE_TYPE.MOLSTAR_PDB_VIEWER
  | EXTERNAL_FILE_TYPE.MOLSTAR_PDBQT_VIEWER
  | EXTERNAL_FILE_TYPE.MOLSTAR_MMCIF_VIEWER;
